export const CampaignTypes = {
  Promotional: 'promotional',
  Informational: 'informational',
};

export const ToneTypes = {
  Friendly: 'friendly',
  Elegant: 'elegant',
  Playful: 'playful',
  Informative: 'informative',
  Persuasive: 'persuasive',
};

export const SendOptions = {
  Now: 'now',
  Schedule: 'schedule',
};

export const AttachmentTypes = {
  Offer: 'offer',
  PromoCode: 'promo_code',
};

export const AudienceOptions = {
  All: 'all',
};

export const CampaignEditMode = {
  Edit: 'edit',
  View: 'view',
};

export const ScheduleMode = {
  Instant: 'instant',
  Scheduled: 'scheduled',
};

export const CreatedBy = {
  User: 'user',
  System: 'system',
};

export const DeliveryStatus = {
  Sending: 'sending',
  Sent: 'sent',
  Queued: 'queued',
  Failed: 'failed',
};
